import { Card, FormGroup } from "@cofano/cck";
import { Box, Grid2 as Grid, useTheme } from "@mui/material";
import { Language } from "imports/Utils";
import { RelationLink, ShipLink } from "utils/LinkUtils";
import { PurchaseCharterFromQuery, PurchaseCharterVoyage } from "view/charters/PurchaseCharterDetails";

type PurchaseCharterInfoBlockProps = {
	charter: PurchaseCharterFromQuery;
	voyage?: PurchaseCharterVoyage;
	color: string;
};

const PurchaseCharterInfoBlock = ({ charter, voyage, color }: PurchaseCharterInfoBlockProps) => {
	const theme = useTheme();
	return (
		<Box mb={1.5}>
			<Card color={color} disablePadding>
				<Box sx={{ backgroundColor: theme.palette.mode === "dark" ? "inherit" : "#EFEFEF", p: 1.5 }}>
					<Grid container spacing={3}>
						<Grid size={{ md: 2, xs: 12 }}>
							<FormGroup label={Language("CHARTER")} labelPlacement="left-center" overflow="hidden">
								{charter.charterNumber}
							</FormGroup>
						</Grid>

						<Grid size={{ md: 2, xs: 12 }}>
							<FormGroup label={Language("CONTRACTOR")} labelPlacement="left-center" overflow="hidden">
								<RelationLink relation={charter.creditor} />
							</FormGroup>
						</Grid>

						<Grid size={{ md: 2, xs: 12 }}>
							<FormGroup label={Language("CUSTOMER")} labelPlacement="left-center" overflow="hidden">
								<RelationLink relation={charter.debtor} />
							</FormGroup>
						</Grid>

						<Grid size={{ md: 2, xs: 12 }}>
							{voyage?.ship && (
								<FormGroup label={Language("SHIP")} labelPlacement="left-center" overflow="hidden">
									<ShipLink ship={voyage.ship} />
								</FormGroup>
							)}
						</Grid>
					</Grid>
				</Box>
			</Card>
		</Box>
	);
};

export default PurchaseCharterInfoBlock;
